import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = "h-10 rounded-xl border-navy-200 bg-white text-sm text-navy-900 focus-visible:ring-navy-900";

export const ChatLeadForm = ({ sessionId, onDone, onCancel }) => {
  const [f, setF] = useState({ name: "", email: "", phone: "", privacy: false });
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.privacy) return setError("Accetta l'informativa privacy per continuare.");
    setSending(true);
    setError("");
    try {
      await axios.post(`${API}/chat/lead`, { ...f, session_id: sessionId });
      onDone(f.name);
    } catch {
      setError("Invio non riuscito. Controlla i dati o chiama lo studio.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="chat-lead-form" className="rounded-2xl border border-navy-100 bg-navy-50 p-4 space-y-3">
      <p className="text-sm font-semibold text-navy-900">Lascia i tuoi contatti: lo studio ti richiamerà.</p>
      <Input data-testid="chat-lead-name" required minLength={2} placeholder="Nome e cognome *" value={f.name} onChange={set("name")} className={field} />
      <Input data-testid="chat-lead-email" required type="email" placeholder="Email *" value={f.email} onChange={set("email")} className={field} />
      <Input data-testid="chat-lead-phone" required minLength={6} type="tel" placeholder="Telefono *" value={f.phone} onChange={set("phone")} className={field} />
      <label className="flex items-start gap-2 text-xs leading-relaxed text-navy-500">
        <Checkbox
          data-testid="chat-lead-privacy"
          checked={f.privacy}
          onCheckedChange={(c) => setF({ ...f, privacy: c === true })}
          className="mt-0.5 rounded border-navy-900 data-[state=checked]:bg-navy-900"
        />
        Acconsento al trattamento dei dati per essere ricontattato. La conversazione sarà inviata allo studio.
      </label>
      {error && <p data-testid="chat-lead-error" className="text-xs text-destructive">{error}</p>}
      <div className="flex gap-2">
        <Button type="submit" disabled={sending} data-testid="chat-lead-submit" className="flex-1 rounded-full bg-navy-900 hover:bg-navy-700 h-10 text-sm">
          {sending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Invia
        </Button>
        <Button type="button" variant="ghost" onClick={onCancel} data-testid="chat-lead-cancel" className="rounded-full h-10 text-sm text-navy-900">
          Annulla
        </Button>
      </div>
    </form>
  );
};
